import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseGovernmentAllocationsAllowedCategoriesAndProductsProps<T> = {
  governmentAllocationId?: string
  filters?: {
    search?: string
    page?: number
    companyBranchId?: string
    productCategoryId?: string
  }
  mapper?: (data: any) => T,
}

export const useGovernmentAllocationsAllowedCategoriesAndProducts = <T,>({
  governmentAllocationId,
  filters: { search = '', page, companyBranchId, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseGovernmentAllocationsAllowedCategoriesAndProductsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['governmentAllocationsAllowedCategoriesAndProducts', governmentAllocationId, search, page, companyBranchId, productCategoryId],
    queryFn: () => {
      return privateAxios.get(`/billing/government_allocations/${governmentAllocationId}/allowed_categories_and_products`, {
        params: {
          search,
          page,
          branch_id_for_consumed_summary: companyBranchId,
          product_category_id: productCategoryId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
